import React from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";


function Instructions() {

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        margin: "0 auto",
        backgroundColor: "#f9f9f9",
        padding: "10px",
        borderRadius: "5px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "flex-start",
    padding: "5px 0",
     backgroundColor: "#f9f9f9",


  }}
>
  <span style={{ fontWeight: "normal", color: "#555", marginRight: "10px" }}>Search:</span>
  <input
    type="text"
    placeholder="Type to Search..."
    style={{
     padding: "10px 16px",
    width: "300px",
    border: "none",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #ffffff, #f9f9f9)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    fontSize: "1rem",
    color: "#333",
    outline: "none",
    transition: "box-shadow 0.3s, transform 0.2s",
    }}
  />
  <Button
    variant="success"
    style={{
     background: "linear-gradient(135deg, #004aad, #005ce6)",  // Gradient for depth
    border: "none",
    padding: "8px 16px",
    height: "38px",
    fontSize: "0.95rem",
    fontWeight: "500",
    borderRadius: "6px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    color: "#fff",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginLeft: "auto", // Instead of fixed 65% margin, use flex or auto for alignment
    display: "block",
    }}
  >
    + Add
  </Button>
</div>
    <div
                style={{
                  marginTop: "5px",
                  fontWeight: "normal",
                  color: "#777",
                  marginRight:"85%"
                }}
              >
                Showing 1 to 0 of 0 entries
              </div>
<br/>
     <Table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "sans-serif",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    overflow: "hidden",
  }}
>
  <thead>
    <tr
      style={{
        background: "linear-gradient(135deg, #004aad, #005ce6)",
        color: "#fff",
        textAlign: "left",
      }}
    >
      <th style={{ padding: "12px 16px", fontSize: "0.95rem" }}>Active</th>
      <th style={{ padding: "12px 16px", fontSize: "0.95rem" }}>Instruction</th>
      <th style={{ padding: "12px 16px", fontSize: "0.95rem" }}>Where</th>
      <th style={{ padding: "12px 16px", fontSize: "0.95rem" }}>Conditions</th>
    </tr>
  </thead>
  <tbody>
    <tr style={{ backgroundColor: "#fafafa" }}>
      <td
        colSpan={4}
        style={{
          textAlign: "center",
          padding: "24px",
          color: "#888",
          fontStyle: "italic",
          fontSize: "0.9rem",
        }}
      >
        No data available in table
      </td>
    </tr>
  </tbody>
</Table>
 <div
                style={{
                  marginTop: "5px",
                  fontWeight: "normal",
                  color: "#777",
                  marginRight:"85%"
                }}
              >
                Showing 1 to 0 of 0 entries
              </div>
    </div>
  );
}

export default Instructions;